import { Flex } from "atoms/grid";
import { A } from "atoms/legacy-typography";
import Loading from "components/Loading";
import Link from "next/link";

const BlogLink = (props) => {
  const { children, href, onClick, loading } = props;
  return (
    <Flex ml={[40, , 0]} mt={40} justifyContent={[, , "center"]}>
      {loading && <Loading />}
      {!loading && (
        <Link href={href} passHref>
          <A onClick={onClick}>{children}</A>
        </Link>
      )}
    </Flex>
  );
};

export default BlogLink;
